import { Injectable } from '@angular/core';
import { API } from 'src/app/configs';
import { HttpService } from 'src/app/core/http/http.service';
import { FileUpload } from '../utils/fileUpload';
import { AppLoadingService } from './apploading.service';
import { GeneralService } from './general.service';
import { Buffer } from 'buffer';

@Injectable({
    providedIn: 'root'
})
export class SignatureService {

    constructor(
        protected fileUpload: FileUpload,
        protected als: AppLoadingService,
        protected httpService : HttpService,
        public gs: GeneralService
    ) {}

    async updateSignature(person_id,file, signature_file_id = false){
        await this.als.setLoaded(false, 'signature');
    
        let url = file;
    
        let size = new Buffer(url, 'base64').length;
        this.fileUpload.setDefault();
        this.fileUpload.replace = true;
        this.fileUpload.origin = 'person';
        this.fileUpload.ref = person_id;
        this.fileUpload.gallery = 'private.person.signature';
        this.fileUpload.resizes = ['original'];
        this.fileUpload.ownerId = null;
    
        this.fileUpload.fileEvent(
          [{
            name: 'signature.png',
            type: 'image/png',
            size: size,
            tags: [308],
            base64: url,
            old_file_id: signature_file_id
          }],308);
    }
    async deleteSignature(id, person_id):Promise<any>{
        return this.httpService.del<any>(API.general.files.fileDelete, {ids : [id], gallery : 'private.person.signature', owner_person_id : person_id})
        .catch((err) => this.gs.error(err));
    }
    getFileupload(){
        return this.fileUpload;
    }
}